import { apiRequest } from './client'
import type { PermissionCatalogEntry, Role } from './types'

export const rolesApi = {
  list: () => apiRequest<{ data: Role[] }>('/roles'),

  permissionCatalog: () => apiRequest<{ data: PermissionCatalogEntry[] }>('/roles/permissions'),

  create: (input: { name: string; description?: string; color?: string; permissionKeys: string[] }) =>
    apiRequest<{ data: Role }>('/roles', { method: 'POST', body: input }),

  update: (id: string, input: { name?: string; description?: string; color?: string; permissionKeys?: string[] }) =>
    apiRequest<{ data: Role }>(`/roles/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/roles/${id}`, { method: 'DELETE' }),
}
